<template>
  <div class="store__header">
    <div class="store__header__center">
      <div class="store__header__center__name">
        {{ store.shopName }}&nbsp;&nbsp;&nbsp;&nbsp;{{ store.merchantEntityName }}
      </div>
      <div class="store__header__center__active">
        上架{{ store.onSaleGoodsNum }}种商品 满{{ price(store.minDeliveryAmount) }}元起送，满{{
          price(store.parcelAmount)
        }}包邮
      </div>
      <div class="store__header__center__tags">
        <span v-for="tag in store.shop_tags" :key="tag.labelName" class="tag">{{ tag.labelShortName }}</span>
      </div>
    </div>
    <div class="store__header__left">
      <img v-if="store.shopIcon" class="store__header__left__logo" :src="store.shopIcon" alt="" />
      <img v-else class="store__header__left__logo" :src="require('@/assets/img/shop-logo.png')" />
    </div>
    <div class="store__header__right">
      <div @click="$emit('customer-service')" class="vertical-align pointer select">
        <img class="middle img" src="@/assets/store/custom-service.png" />
        <span class="store__header__right__text middle">联系客服</span>
      </div>
    </div>
  </div>
</template>

<script>
import { priceFenToYuan } from '@/helpers/utils';
export default {
  props: {
    store: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  methods: {
    price(val) {
      return priceFenToYuan(val);
    }
  }
};
</script>

<style lang="scss" scoped>
.store {
  &__header {
    height: 114px;
    margin: 12px 0;
    padding: 16px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    &__center,
    &__left,
    &__right {
      float: left;
    }
    &__center {
      padding: 0 114px 0 96px;
      width: 100%;
      height: 100%;
      overflow: hidden;
      &__name {
        font-size: 24px;
        font-weight: 500;
        color: #262626;
        line-height: 1;
      }
      &__active {
        margin-top: 12px;
        margin-bottom: 10px;
        font-size: 12px;
        font-weight: 400;
        color: #595959;
        line-height: 1.5;
      }
      &__tags {
        line-height: 16px;
        .tag {
          display: inline-block;
          height: 16px;
          padding: 2px 4px;
          font-size: 12px;
          font-weight: 400;
          color: #ff8300;
          line-height: 1;
          background: #fff6ec;
          border-radius: 2px;
          & + .tag {
            margin-left: 8px;
          }
        }
      }
    }
    &__left {
      width: 80px;
      height: 100%;
      margin-left: -100%;
      &__logo {
        width: 80px;
        height: 80px;
      }
    }
    &__right {
      position: relative;
      width: 114px;
      height: 100%;
      margin-left: -114px;

      .vertical-align {
        position: absolute;
        height: 20px;
        top: 0;
        bottom: 0;
        margin: auto;
        line-height: 20px;
      }

      &__text {
        margin-left: 4px;
        font-size: 14px;
        font-weight: 400;
        color: #1e8dff;
        line-height: 1;
      }
      .img {
        width: 14px;
        height: 14px;
      }
    }

    &__details {
    }
  }
}
</style>
